var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1852 175C78.6424 173.83 77.9019 171.822 77.9097 169.099C77.9803 146.303 77.9489 123.508 77.9489 100.712C77.9489 96.8928 79.5475 95.3079 83.3911 95.3079C94.5577 95.3079 105.724 95.3079 116.891 95.3079C120.331 95.3079 122.039 97.0024 122.039 100.419C122.039 123.312 122.012 146.205 122.082 169.095C122.09 171.815 121.346 173.822 118.807 174.996H81.1813L81.1852 175Z",
    fill: "url(#paint0_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2757 175C25.7289 173.834 24.9884 171.822 25.0001 169.103C25.0824 152.119 25.0393 135.134 25.0432 118.146C25.0432 114.53 26.6967 112.891 30.3405 112.891C41.5541 112.891 52.7676 112.891 63.9812 112.891C67.4252 112.891 69.1335 114.585 69.1335 118.002C69.1335 135.037 69.0943 152.068 69.1766 169.103C69.1883 171.822 68.44 173.83 65.901 175.004H28.2757V175Z",
    fill: "url(#paint1_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.099 175C131.556 173.834 130.8 171.822 130.824 169.103C130.926 157.977 130.863 146.851 130.867 135.721C130.867 132.105 132.52 130.47 136.164 130.47C147.378 130.47 158.591 130.47 169.801 130.47C173.245 130.47 174.953 132.16 174.953 135.577C174.957 146.753 174.894 157.93 174.996 169.103C175.02 171.826 174.26 173.83 171.721 175H134.095H134.099Z",
    fill: "url(#paint2_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0134 54.3348C93.594 61.8954 105.959 62.2163 115.046 54.3113C115.9 55.2857 116.82 56.2132 117.604 57.2424C120.5 61.054 121.969 65.3783 122.031 70.1605C122.071 73.0368 122.055 75.9171 122.039 78.7973C122.02 81.8067 120.213 83.5834 117.161 83.5873C105.705 83.5951 94.2522 83.5951 82.7958 83.5873C79.7553 83.5873 77.8903 81.7911 77.9687 78.7621C78.0862 74.2891 78.0118 69.7691 78.6348 65.3588C79.2499 61.0188 81.7065 57.4224 85.0095 54.3348H85.0134Z",
    fill: "url(#paint3_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1115 71.9098C40.3434 79.2043 52.7049 80.0496 62.0966 71.9567C65.2781 74.8605 67.3977 78.4099 68.44 82.5659C69.6702 87.4655 69.1256 92.4707 69.0316 97.429C68.9924 99.55 66.9981 101.143 64.8079 101.151C53.0105 101.182 41.2132 101.182 29.4158 101.151C27.1629 101.147 25.1177 99.4952 25.1255 97.3311C25.1412 92.5177 25.1059 87.6572 25.7407 82.9064C26.3205 78.5743 28.8085 74.974 32.1075 71.9098H32.1115Z",
    fill: "url(#paint4_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.911 89.5082C146.856 97.3115 159.202 97.1197 167.857 89.5395C168.163 89.8056 168.504 90.06 168.794 90.3652C172.759 94.5525 174.839 99.5264 174.945 105.287C175 108.214 174.976 111.141 174.953 114.069C174.929 116.91 173.111 118.741 170.259 118.745C158.705 118.761 147.154 118.761 135.6 118.745C132.735 118.745 130.816 116.921 130.886 114.108C131 109.584 130.925 105.021 131.544 100.556C132.148 96.2118 134.601 92.6076 137.911 89.5082Z",
    fill: "url(#paint5_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.059 25C107.37 25.0274 113.278 31.0031 113.219 38.3133C113.161 45.5296 107.197 51.3879 99.9372 51.3605C92.6338 51.3331 86.7175 45.3496 86.7763 38.0472C86.8312 30.8348 92.7984 24.9726 100.059 25Z",
    fill: "url(#paint6_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8629 55.677C33.8982 48.3981 39.9085 42.5124 47.2393 42.5789C54.4799 42.6455 60.3414 48.5938 60.3061 55.8375C60.2708 63.1203 54.2605 69.006 46.9297 68.9356C39.697 68.869 33.8277 62.9129 33.859 55.677H33.8629Z",
    fill: "url(#paint7_linear_26_90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 60.1578C160.295 60.1931 166.196 66.1766 166.129 73.4868C166.063 80.6992 160.091 86.5497 152.827 86.5145C145.528 86.4793 139.619 80.4879 139.682 73.1816C139.745 65.9731 145.72 60.1226 152.984 60.1539L152.988 60.1578Z",
    fill: "url(#paint8_linear_26_90)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_90",
    x1: 99.996,
    y1: 95.3079,
    x2: 99.996,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_90",
    x1: 47.0883,
    y1: 112.891,
    x2: 47.0883,
    y2: 175.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_90",
    x1: 152.91,
    y1: 130.47,
    x2: 152.91,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_90",
    x1: 100.011,
    y1: 54.3113,
    x2: 100.011,
    y2: 83.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_90",
    x1: 47.179,
    y1: 71.9098,
    x2: 47.179,
    y2: 101.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26_90",
    x1: 152.931,
    y1: 89.5082,
    x2: 152.931,
    y2: 118.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26_90",
    x1: 99.9979,
    y1: 24.9999,
    x2: 99.9979,
    y2: 51.3606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26_90",
    x1: 47.0826,
    y1: 42.5784,
    x2: 47.0826,
    y2: 68.9362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26_90",
    x1: 152.906,
    y1: 60.1538,
    x2: 152.906,
    y2: 86.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIntegration);
export default __webpack_public_path__ + "static/media/Event_Integration.2a8c3e9cd46ad2426498a2e2a81476e0.svg";
export { ForwardRef as ReactComponent };